import WcMine from './WcMine.vue'
WcMine.install = function (Vue){
	Vue.component(WcMine.name,WcMine)
}
export default WcMine


// WEBPACK FOOTER //
// ./src/components/mine/index.js